var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('Sales cheques'),"description":_vm.$t('From here you can control the sales cheques')}}),_c('indexTable',{attrs:{"searchText":_vm.$t('Find a cheque'),"emptyTableText":_vm.$t('There Are No sales cheques'),"emptyTableSubText":_vm.$t('Try adding some items to the table and try again'),"buttonRole":_vm.$checkRole('sales_cheques_add'),"statusSearch":true,"statusValues":[
          { title: _vm.$t('Active'), value: '' },
          { title: _vm.$t('Waiting'), value: 0 },
          {
            title: _vm.$t('Driven'),
            value: 1
          }
        ],"cloumns":[
          { column: 'code', title: _vm.$t('batch'), type: 'mainLink', sort: true },
          {
            column: 'client_type',
            title: _vm.$t('Customer name'),
            type: 'clintLink',
            sort: true
          },
          {
            column: 'safe_id',
            title: _vm.$t('Treasury'),
            type: 'link',
            to: 'safe',
            sort: true,
            link: true
          },
          {
            column: 'created_date',
            title: _vm.$t('Registration date'),
            type: 'text',
            sort: true
          },
          { column: 'date', title: _vm.$t('Payment date'), type: 'text', sort: true },
          {
            column: 'description',
            title: _vm.$t('Thats about'),
            type: 'text',
            sort: true
          },
          {
            column: 'cost',
            title: _vm.$t('Amount'),
            type: 'text',
            sort: true
          },
          { column: 'user_name', title: _vm.$t('Responsible name'), type: 'text', sort: true },
          {
            column: 'stat',
            title: _vm.$t('Active'),
            type: 'status',
            sort: true,
            values: [
              { title: _vm.$t('Waiting'), value: 0, color: 'info' },
              { title: _vm.$t('Driven'), value: 1, color: 'success' },
              { title: _vm.$t('Converted'), value: 2, color: 'success' },
              { title: _vm.$t('Refused'), value: 3, color: 'danger' }
            ]
          },
          {
            column: 'options',
            title: _vm.$t('Settings'),
            type: 'options',
            options: [
              { name: 'show' },
              { name: 'printSalesCheque', role: true },
              {
                name: 'paySalesCheque',
                role: _vm.$checkRole('sales_cheques_edit')
              },
              { name: 'edit', role: _vm.$checkRole('sales_cheques_edit') },
              { name: 'delete', role: _vm.$checkRole('sales_cheques_delete') }
            ]
          }
        ],"deleteText":{
          attention: _vm.$t('Attention'),
          areYouReallySureToDeleteTheItem: _vm.$t('Are you really sure to delete the item'),
          close: _vm.$t('Close'),
          confirm: _vm.$t('Confirm'),
          loading: _vm.$t('Loading')
        }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }